// import { compare_version } from "./mgtv/version";

// const regexp = /\/\/vipcdn.mgtv.com/i;

// //是否支持schema格式，目前安卓中是支持的，ios不支持
// let _isSupportWebp = -1
// export function isSupportsWebP() {
//   function t() {
//     const canvas = typeof document === 'object' ? document.createElement('canvas') : {};
//     canvas.width = canvas.height = 1;
//     return canvas.toDataURL ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5 : false;
//   }
//   if (_isSupportWebp === -1) {
//     _isSupportWebp = t() ? 1 : 0
//   }
//   return !!_isSupportWebp
// };

// //iphone app中使用schema支持webp https://jira.imgo.tv/browse/IPHONEAPP-11417
// let _isSupportWebpSchema = -1
// export function isSupportWebPSchema() {
//   function t() {
//     if (!gact.is_iphone_app || gact.is_debug) {
//       return false
//     }
//     try {
//       const osVersion = parseFloat(window.$bus.device_info.osVersion)
//       if (osVersion >= 11 && compare_version('>=', '6.6.8')) {
//         return true
//       }
//     } catch (e) {

//     }
//     return false
//   }

//   if (_isSupportWebpSchema === -1) {
//     _isSupportWebpSchema = t() ? 1 : 0
//     console.log('_isSupportWebpSchema', !!_isSupportWebpSchema)
//   }
//   return !!_isSupportWebpSchema
// }


// export function towebp(url) {
//   if (url.endsWith('webp')) { //已是webp
//     return url
//   }
//   if (url.match(regexp)) {
//     let webp = url;
//     if (isSupportsWebP()) {
//       webp = url + '?x-oss-process=image/format,webp';
//     } else if (isSupportWebPSchema()) {
//       const isPng = /png$/i.test(url)
//       if (isPng) {
//         //origin-format=png 通知浏览器转为png，默认转jpeg
//         webp = url.replace(/^https?:\/\//, 'mgwebp://') + '?origin-format=png&x-oss-process=image/format,webp'
//       } else {
//         webp = url.replace(/^https?:\/\//, 'mgwebp://') + '?x-oss-process=image/format,webp'

//       }
//     }
//     return webp;
//   }
//   return url;
// }

import mgwebpCls from '@mgtv/mgwebp'

function huidu() {
  const did = window.$bus.device_info.did
  if (!did) {
    return false
  }
  if (did[0] > '5') {
    return false
  }
  return true
}

let mgWebp = null
export function towebp(url) {
  if (!mgWebp) {
    mgWebp = createWebpInst()
  }

  //灰度,did第一位为<=5时使用webpschema
  // if (mgWebp.mode === 'webpschema') {
  //   if (!huidu()) {
  //     return url
  //   }
  // }
  return mgWebp.auto(url)
}


export function isSupportWebPSchema() {
  if (!mgWebp) {
    mgWebp = createWebpInst()
  }
  return mgWebp.mode === 'webpschema'
}


export function createWebpInst() {
  let inst = null
  const getWebp = (url) => {
    const sym = url.indexOf('?') >= 0 ? '&' : '?'
    if (url.indexOf('vipcdn.mgtv.com') >= 0) {
      return url + sym + 'x-oss-process=image/format,webp'
    }
    return url
  }
  inst = new mgwebpCls({
    deviceInfo: gact.is_iphone_app ? window.$bus.device_info : null,
    getWebp
  })
  console.log('webpmode', inst.mode)
  return inst
}
